"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MapperGroupsLabel;
(function (MapperGroupsLabel) {
    MapperGroupsLabel["AMIS"] = "AMIS";
    MapperGroupsLabel["Aguascalientes"] = "Aguascalientes";
    MapperGroupsLabel["Baja California Sur"] = "Baja California Sur";
    MapperGroupsLabel["Campeche"] = "Campeche";
    MapperGroupsLabel["Chihuahua"] = "Chihuahua";
    MapperGroupsLabel["Colima"] = "Colima";
    MapperGroupsLabel["Consultas de esta placa en Autofact"] = "Consultas de esta placa en Autofact";
    MapperGroupsLabel["Consultas de este VIN en Autofact"] = "Consultas de este VIN en Autofact";
    MapperGroupsLabel["Estado Cdmx"] = "Estado Cdmx";
    MapperGroupsLabel["Estado Mexico"] = "Estado Mexico";
    MapperGroupsLabel["Estado de emplacado"] = "Estado de emplacado";
    MapperGroupsLabel["Guadalajara"] = "Guadalajara";
    MapperGroupsLabel["Guadalupe"] = "Guadalupe";
    MapperGroupsLabel["Guanajuato"] = "Guanajuato";
    MapperGroupsLabel["Guerrero"] = "Guerrero";
    MapperGroupsLabel["Hidalgo"] = "Hidalgo";
    MapperGroupsLabel["Historial de placas"] = "Historial de placas";
    MapperGroupsLabel["Michoacan"] = "Michoacan";
    MapperGroupsLabel["Morelos"] = "Morelos";
    MapperGroupsLabel["Nuevo Le\u00F3n"] = "Nuevo Le\u00F3n";
    MapperGroupsLabel["OCRA"] = "OCRA";
    MapperGroupsLabel["Oaxaca"] = "Oaxaca";
    MapperGroupsLabel["PGJ"] = "PGJ";
    MapperGroupsLabel["Puebla"] = "Puebla";
    MapperGroupsLabel["RAPI"] = "RAPI";
    MapperGroupsLabel["Repuve"] = "Repuve";
    MapperGroupsLabel["San Nicol\u00E1s"] = "San Nicol\u00E1s";
    MapperGroupsLabel["Sinaloa"] = "Sinaloa";
    MapperGroupsLabel["Tamaulipas"] = "Tamaulipas";
    MapperGroupsLabel["Tlaxcala"] = "Tlaxcala";
    MapperGroupsLabel["VIN Decoder"] = "VIN Decoder";
    MapperGroupsLabel["Veracruz"] = "Veracruz";
    MapperGroupsLabel["Zacateca"] = "Zacateca";
    MapperGroupsLabel["general"] = "general";
    MapperGroupsLabel["infraction-plated-state"] = "infraction-plated-state";
    MapperGroupsLabel["rug"] = "rug";
    MapperGroupsLabel["tax-plated-state"] = "tax-plated-state";
})(MapperGroupsLabel || (MapperGroupsLabel = {}));
exports.default = MapperGroupsLabel;
